import {renderConfirmPopup} from "../../../api/api-popups";
import {ConfirmPopupTypes} from "../../visComponents/constants";
import store from "../../../store";
import {removeFromCart} from "../../../actions/actionFunctions";

/**
 * Common func to call question popup
 * @param cartItem {cartItemInterface}
 * @param navItem {navItem}
 * @param quoteIndex {Number}
 * @param fromDelete {boolean}
 * @return {boolean}
 */
export const checkForDeletePopup = (cartItem, navItem, quoteIndex, fromDelete = false) => {
  const {fabricatorState, cartState} = store.getState();
  if (fabricatorState.settings.useCategorySwitching) {
    if (cartItem.partId === "room" && cartItem.cartFeature && (fromDelete || (navItem.part.dbFeature.id !== cartItem.cartFeature.dbFeature.id))
      && cartState.cartItems.some(cItem => cItem.partId !== "room" && cItem.currentQuote === quoteIndex)) {
      renderConfirmPopup(ConfirmPopupTypes.DeleteCartItemsPopup, {
        cartItem, // old
        navItem, // new
        fromDelete
      });
      return true
    }
  }
  return false
}
/**
 * Common func to remove features
 * @param quoteIndex {Number}
 * @return {boolean}
 */
export const removeCartItemsWithQuoteIndex = (quoteIndex) => {
  const {cartState} = store.getState();
  const cartItemsToRemove = cartState.cartItems.filter(cItem => cItem.currentQuote === quoteIndex);
  if (cartItemsToRemove.length) {
    cartItemsToRemove.forEach(cItem => {
      store.dispatch(removeFromCart(cItem));
    })
  }
}

/**
 * Cheks if we selected something from the previous wizard step
 * @param quoteIndex {number}
 * @param wizardItemId {number}
 * @param wizardStep {number}
 * @param applyFunction {function} // will be called on yes click
 * @return {boolean}
 */
export const checkForWizardPreviousChanges = (quoteIndex, wizardItemId, wizardStep, applyFunction) => {
  const {cartState} = store.getState();
  const cartItemsToRemove = cartState.cartItems.filter(cItem => {
    return cItem.currentQuote === quoteIndex && cItem.fromWizardId === wizardItemId && cItem.fromWizardStep > wizardStep
  });
  if (cartItemsToRemove.length) {
    console.log("cartItemsToRemove", cartItemsToRemove);
    const finalFunction = () => {
      cartItemsToRemove.forEach(cItem => {
        store.dispatch(removeFromCart(cItem));
      })
      applyFunction()
    }
    renderConfirmPopup(ConfirmPopupTypes.ChangeWizardToPreviousStepSelection, {
      applyFunction: finalFunction.bind(this)
    });
    return true
  }
  return false
}

